import { IconChevronsLeft, IconChevronsRight } from "@/assets/icons";
import { Pagination as MuiPagination, PaginationItem, styled } from "@mui/material";
import { FC } from "react";

type Props = {
  totalPage: number;
  page: number;
  onChangePage: (page: number) => void;
};

/** Callback-based pagination with page numbers (matches internal Pagination style) */
export const SharedPagination: FC<Props> = ({ totalPage, page, onChangePage }) => {
  return (
    <StyledPagination
      page={page}
      count={totalPage > 0 ? totalPage : 1}
      variant="outlined"
      shape="rounded"
      showFirstButton
      showLastButton
      onChange={(_e, value) => onChangePage(value)}
      renderItem={(item) => (
        <PaginationItem slots={{ first: IconChevronsLeft, last: IconChevronsRight }} {...item} />
      )}
    />
  );
};

const StyledPagination = styled(MuiPagination)(() => ({
  "& .MuiPaginationItem-root": {
    border: "2px solid #cfd4d9",
    borderRadius: 8,
    minWidth: 40,
    height: 40,
    fontSize: 14,
    fontWeight: 500,
    color: "#4a4a4a",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxSizing: "border-box",
  },
  "& .MuiPaginationItem-root.Mui-selected": {
    backgroundColor: "#C34A24",
    color: "#fff",
    border: "none",
    "&:hover": {
      backgroundColor: "#C34A24",
    },
  },
  "& .MuiPaginationItem-ellipsis": {
    border: "2px solid transparent",
    minWidth: 48,
    height: 48,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    lineHeight: 1,
    fontWeight: 500,
    color: "#4a4a4a",
  },
  "& .MuiPaginationItem-root.Mui-disabled": {
    border: "2px solid transparent",
    backgroundColor: "#f2f2f2",
    color: "#b0b0b0",
    pointerEvents: "none",
  },
}));
